(function(){
 'use strict';
 // This announcement is supplied asynchronously by the existing Essential app.
 // If the app/bar is disabled, no replacement banner is created.
 var id='7cc1aad6-1c85-42a3-bff2-9f9eb892614e';
 var observer,timer;
 function enhance(){
  var cta=document.querySelector('a.essential_annoucement_bar_cta_'+id);
  if(!cta)return false;
  var banner=cta.closest('.essential_annoucement_bar_wrapper');
  if(!banner)return false;
  if(cta.closest('.eg-contact-call-actions'))return true;
  var content=cta.parentElement;
  var copy=content.querySelector('.essential_annoucement_titles_outside_wrapper_'+id);
  var subtitle=content.querySelector('.essential_annoucement_bar_subheading_'+id);
  var actions=document.createElement('div');actions.className='eg-contact-call-actions';
  var book=document.createElement('a');book.className=cta.className+' eg-contact-call-book';
  book.href='/pages/book-a-call';book.textContent='Book a call';
  banner.classList.add('eg-contact-call-banner');content.classList.add('eg-contact-call-content');
  if(copy)copy.classList.add('eg-contact-call-copy');
  if(subtitle)subtitle.textContent='Message us or book a call — whichever works for you.';
  cta.before(actions);actions.append(cta,book);
  return true;
 }
 function stop(){if(observer)observer.disconnect();clearTimeout(timer);}
 function start(){
  stop();if(enhance())return;
  observer=new MutationObserver(function(){if(enhance())stop();});
  observer.observe(document.body,{childList:true,subtree:true});
  timer=setTimeout(stop,30000);
 }
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});else start();
 document.addEventListener('shopify:section:load',start);
})();
